<template>
	<div>
		<div v-if="isVisible" class="alert alert-success">{{ msg }}</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			msg: "Erfolgreich gespeichert",
			isVisible: false
		}
	},

	methods: {
		display () {
			this.isVisible = true
			setTimeout( () => {
				this.isVisible = false
			}, 2000)
		}
	}
}
</script>


// WEBPACK FOOTER //
// custom-message.vue?3041bece